import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/app/PrivacyPolicy.css';
import WhatsAppBanner from './WhatsAppBanner';
import Nav from './Nav';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <WhatsAppBanner />
      <Nav />
      <section className="privacy-section">
        <div className="privacy-container">
          <h1>{t('privacyPolicy.title')}</h1>

          <h2>{t('privacyPolicy.informationWeCollect.title')}</h2>
          <p>
            {t('privacyPolicy.informationWeCollect.paragraph')}
          </p>

          <h2>{t('privacyPolicy.howWeUseYourInformation.title')}</h2>
          <p>
            {t('privacyPolicy.howWeUseYourInformation.paragraph')}
          </p>

          <h2>{t('privacyPolicy.informationSecurity.title')}</h2>
          <p>
            {t('privacyPolicy.informationSecurity.paragraph')}
          </p>

          <h2>{t('privacyPolicy.yourRights.title')}</h2>
          <p>
            {t('privacyPolicy.yourRights.paragraph')}
          </p>

          <h2>{t('privacyPolicy.changesToPolicy.title')}</h2>
          <p>
            {t('privacyPolicy.changesToPolicy.paragraph')}
          </p>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
